import React, { useState, useEffect } from 'react';
import { levelService } from '../../services/supabaseService';

const LevelSelectorSimple = ({
  selectedLevelIds = [],
  onChange = () => {},
  disabled = false
}) => {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLevels();
  }, []);

  const loadLevels = async () => {
    try {
      setLoading(true);
      console.log('📊 LevelSelectorSimple: Cargando niveles...');
      const { data, error } = await levelService.getAllLevels();
      
      if (error) {
        console.error('❌ Error:', error);
        return;
      }
      
      console.log(`✅ Cargados ${data?.length || 0} niveles`);
      setLevels(data || []);
    } catch (err) {
      console.error('❌ Exception:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (levelId) => {
    const newSelected = selectedLevelIds.includes(levelId)
      ? selectedLevelIds.filter(id => id !== levelId)
      : [...selectedLevelIds, levelId];
    onChange(newSelected);
  };

  if (loading) {
    return <div style={{ padding: '10px', color: '#999' }}>Cargando niveles...</div>;
  }

  if (levels.length === 0) {
    return <div style={{ padding: '10px', color: '#d32f2f' }}>⚠️ No hay niveles en la BD</div>;
  }

  return (
    <div style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '12px', maxHeight: '400px', overflowY: 'auto', background: '#f9f9f9' }}>
      <div style={{ marginBottom: '8px', fontSize: '12px', color: '#666', fontWeight: '500' }}>
        {selectedLevelIds.length} de {levels.length} seleccionados
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        {levels.map(level => (
          <label
            key={level.id}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              padding: '8px',
              background: selectedLevelIds.includes(level.id) ? '#e3f2fd' : 'white',
              border: '1px solid ' + (selectedLevelIds.includes(level.id) ? '#8b5cf6' : '#ddd'),
              borderRadius: '4px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s'
            }}
          >
            <input
              type="checkbox"
              checked={selectedLevelIds.includes(level.id)}
              onChange={() => handleToggle(level.id)}
              disabled={disabled}
              style={{
                marginRight: '8px',
                marginTop: '2px',
                cursor: disabled ? 'not-allowed' : 'pointer'
              }}
            />
            <div>
              <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>
                {level.name}
              </div>
              {level.description && (
                <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
                  {level.description}
                </div>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default LevelSelectorSimple;
